export default __webpack_public_path__ + "static/16-33b4d5ef13d1983f809408e6312069b7.webp";